// IconButton Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Tooltip from '../tooltip/tooltip.jsx'
import SvgIcon from '../svgicon/svgicon.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class IconButton extends Component {
  constructor (props) {
    super(props)

    this._svgSize = {
      normal: '12',
      big: '26',
      huge: '44',
      small: '10'
    }
  }

  static get propTypes () {
    return {
      icon: PropTypes.string,
      className: PropTypes.string,
      type: PropTypes.oneOf([
        'transparent',
        'success',
        'error',
        'primary',
        'secondary',
        'disabled',
        'invert',
        'alert',
        'default',
        'warning'
      ]),
      size: PropTypes.oneOf(['normal', 'big', 'huge', 'small', 'mobile']),
      hasBorder: PropTypes.bool,
      iconSize: PropTypes.string,
      tooltip: PropTypes.string,
      label: PropTypes.string,
      alignLabel: PropTypes.string,
      tooltipPosition: PropTypes.oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'bottomleft',
        'bottomright'
      ]),
      target: PropTypes.string,
      href: PropTypes.string,
      canHover: PropTypes.bool,
      onClick: PropTypes.func,
      onRenderTooltip: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      icon: '',
      className: '',
      type: 'transparent',
      size: 'normal',
      hasBorder: false,
      iconSize: '',
      tooltip: '',
      label: '',
      alignLabel: 'left',
      tooltipPosition: 'top',
      target: '',
      href: '',
      canHover: false,
      onClick: null,
      onRenderTooltip: null
    }
  }

  render () {
    const {
      icon,
      type,
      iconSize,
      size,
      className,
      hasBorder,
      canHover,
      tooltip,
      label,
      alignLabel,
      tooltipPosition,
      target,
      href,
      onClick,
      onRenderTooltip,
      children
    } = this.props

    const _className = classnames(
      'cicon-button',
      `cicon-button_${type}`,
      `cicon-button_${size}`,
      className,
      {
        hasborder: hasBorder,
        canhover: canHover,
        hasclick: !!(onClick || href || tooltip || onRenderTooltip),
        [`alignabel-${alignLabel}`]: alignLabel
      }
    )
    const labelElement = label ? (
      <div className='label'>
        <IntlMessage ident={label} />
      </div>
    ) : null

    const iconElement = (
      <>
        {tooltip && (
          <Tooltip
            trigger={this}
            message={tooltip}
            position={tooltipPosition}
          />
        )}
        {onRenderTooltip && onRenderTooltip(this)}
        {alignLabel === 'right' && labelElement}
        <div className='content'>
          {children || (
            <SvgIcon
              name={icon}
              size={iconSize || this._svgSize[size] || '16'}
              className='icon'
            />
          )}
        </div>
        {alignLabel === 'left' && labelElement}
      </>
    )
    if (href) {
      return (
        <a className={_className} href={href} target={target || '_self'}>
          {iconElement}
        </a>
      )
    }

    return (
      <div className={_className} onClick={onClick}>
        {iconElement}
      </div>
    )
  }
}

export default IconButton
